import React from 'react';
import './matrix.css'

import MatrixCell from './components/matrix-cell'
import {pin_state} from "../peripheral";

class Matrix extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            x: -1,
            y: -1,
            caret: 0,
            columns: this.props.columns
        };
        this.style = {
            height: (props.name === 'pinMap')?'24px':'auto',
            display: 'inline-block',
            marginTop: '5px',
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.columns !== prevProps.columns) {
            this.setState({
                columns: this.props.columns
            })
        }
    }
    getHeight() {
        return this.state.columns[0].length;
    }

    getWidth() {
        return this.state.columns.length;
    }

    getCellValue(x, y) {
        if(x < 0 || y < 0 || x > this.getWidth()-1 || y > this.getHeight()-1) return '';
        return this.state.columns[x][y];
    }

    setCellValue(x, y, val) {
        var columns = this.state.columns;
        columns[x][y] = val;
        this.setState({
            columns: columns,
        })
    }

    setCell(caret, cellX, cellY) {
        // Remove columns / rows if needed
        this.truncate(cellX, cellY);
        this.setState({
            caret: caret,
            x: cellX,
            y: cellY,
        });
        if ((this.getCellValue(cellX,cellY) !== pin_state.NOT_SELECTABLE) &&
            (this.getCellValue(cellX,cellY) !== pin_state.DISABLED)){
            if (this.props.clickedPinCallback != null){
                this.props.clickedPinCallback(this.props.title, cellX, cellY);
            }
        }
    }

    moveCell(dx, dy) {
        var cellX = this.state.x;
        var caretPos;

        if(this.state.caret+dx > (''+this.getCellValue(cellX, this.state.y)).length) {
            cellX++;
            caretPos = 0; // First pos in next cell
        } else if(this.state.caret+dx < 0) {
            cellX--;
            caretPos = (''+this.getCellValue(cellX, this.state.y)).length;
        } else {
            caretPos = this.state.caret+dx;
        }
        var cellY = this.state.y+dy;

        // Negative position is not allowed
        if(cellX < 0) return;
        if(cellY < 0) return;

        // If outside bounds and resizing is disabled
        if(!this.isResizeableX() && cellX >= this.getWidth()) cellX = this.state.x;
        if(!this.isResizeableY() && cellY >= this.getHeight()) cellY = this.state.y;

        // Remove columns / rows if needed
        this.truncate(cellX, cellY);

        // Add column / row if needed
        if(cellX >= this.getWidth() && this.isResizeableX()) {
            this.addColumn();
        }
        if(this.state.y+dy >= this.getHeight() && this.isResizeableY()) {
            this.addRow();
        }

        this.setState({
            caret: caretPos,
            x: cellX,
            y: cellY
        })
    }

    addRow() {
        var columns = this.state.columns;
        for (var i = 0; i < columns.length; i++) {
            columns[i].push('');
        }
        this.setState({
            height: this.getHeight() + 1,
            columns: columns
        });
    }

    addColumn() {
        var columns = this.state.columns;
        var newColumn = new Array(this.getHeight());
        for (var i = 0; i < newColumn.length; i++) {
            newColumn[i] = ''
        }
        columns.push(newColumn);

        this.setState({
            width: this.state.width + 1,
            columns: columns
        })
    }

    isRowEmpty() {
        for (var i = 0; i < this.state.columns.length; i++) {
            var col = this.state.columns[i];
            if((''+col[col.length-1]).length > 0) {
                return false;
            }
        }

        return true;
    }

    isColumnEmpty(col) {
        var column = this.state.columns[col];
        for (var i = 0; i < column.length; i++) {
            if((''+column[i]).length > 0) return false;
        }

        return true;
    }

    removeRow(row) {
        for (var i = 0; i < this.state.columns.length; i++) {
            this.state.columns[i].splice(row, 1)
        }
        this.setState({
            columns: this.state.columns
        })
    }

    removeColumn(col) {
        this.state.columns.splice(col, 1);
        this.setState({
            columns: this.state.columns
        });
    }

    truncate(cellX, cellY) {
        for (var x = this.getWidth()-1; x > cellX; x--) {
            if(this.isColumnEmpty(x) && this.isResizeableX()) this.removeColumn(x)
        }
        for (var y = this.getHeight()-1; y > cellY; y--) {
            if(this.isRowEmpty(y) && this.isResizeableY()) this.removeRow(y)
        }
    }

    render() {
        var activeCell = this.state.x * this.getHeight() + this.state.y;
        var currentCell = 0;
        var colStyle = {
            display: 'flex',
        };
        var columns = this.state.columns.map(function(columnValues, x) {
            var column = columnValues.map(function(value, y) {
                var active = currentCell === activeCell;
                var ppin = this.props.pinMap[y];
                var cell =
                    <MatrixCell
                        selectedBoard={this.props.selectedBoard}
                        key={this.props.name+"-"+x+'-'+y}
                        p_pin={ppin}
                        type={this.props.type}
                        pinStatus={this.props.pinStatus}
                        value={value}
                        matrix={this}
                        x={x} y={y}
                        active={active}
                        readonly={this.props.readonly} />;
                currentCell++;
                return cell;
            }, this);

            var columnStyle = {
                float: 'left',
                padding: '2px 2px',
                display:'flex',
            };

            return (
                <div key={this.props.name + "-row-" + x} style={colStyle}>
                    <div className={'subTitle_style'}>
                        <span>
                            {this.props.pinNames[x]}
                        </span>
                    </div>
                    <div key={x} style={columnStyle}>
                        {column}
                    </div>
                </div>);

        }, this);


        var wrapper_style = {
            // backgroundColor: 'green',
            display: 'flex',
            paddingBottom: '3px'
        };
        var title_style = {
            width: '7ch',
            minWidth:'7ch'
        };
        return (
            <div className={"matrix-wrapper"} style={wrapper_style}>
                <div className={"matrix-title"} style={title_style}>{this.props.title}</div>
                <div style={this.style}>
                    {columns}
                </div>
            </div>
        );
    }
}

// Matrix.propTypes = {
//     columns: React.PropTypes.array,
//     resize: React.PropTypes.oneOf(['both', 'vertical', 'horizontal', 'none']),
//     readonly: React.PropTypes.bool
// }
export default Matrix;
